import PhoneInput from 'src/components/PhoneInput'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Footer from 'src/components/Footer'
import NewHeader from 'src/New Codes/components/NewHeader'
import { url } from 'src/helpers'
import { formatExperience, renderBody, timeAgo } from './textUtils'
import './PublicPages.css'

const JobDetail = () => {
    const { id } = useParams()
    const [job, setJob] = useState(null)
    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [submitted, setSubmitted] = useState(false)

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [coverNote, setCoverNote] = useState('')
    const [resume, setResume] = useState(null)

    async function fetchData() {
        setLoading(true)
        try {
            const response = await fetch(url + 'careers/jobs/' + id)
            const data = await response.json()
            if (data?.status === 200) {
                setJob(data?.data)
            } else {
                toast.error(data?.message || 'Job not found')
            }
        } catch (err) {
            toast.error('Failed to load job posting')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!id) return
        window.scrollTo(0, 0)
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    async function handleApply(e) {
        e.preventDefault()
        if (resume && resume.size > 5 * 1024 * 1024) {
            toast.error('Resume must be 5 MB or smaller')
            return
        }
        setSubmitting(true)
        try {
            const formData = new FormData()
            formData.append('name', name)
            formData.append('email', email)
            formData.append('phone', phone)
            formData.append('cover_note', coverNote)
            if (resume) formData.append('resume', resume)

            const response = await fetch(url + 'careers/jobs/' + id + '/apply', {
                method: 'POST',
                body: formData
            })
            const data = await response.json()
            if (data?.status === 200) {
                toast.success(data?.message)
                setSubmitted(true)
            } else {
                toast.error(data?.message || 'Failed to submit application')
            }
        } catch (err) {
            toast.error('Failed to submit application')
        } finally {
            setSubmitting(false)
        }
    }

    useEffect(() => {
        if (job?.title) document.title = job.title + ' | Careers | Beba Mzigo'
    }, [job])

    return (
        <>
            <NewHeader />
            <div className="public-page">
                {loading ? (
                    <div className="pp-state">Loading...</div>
                ) : job ? (
                    <>
                        <header className="pp-hero jd-hero">
                            <div className="pp-wrap">
                                <Link to="/careers" className="jd-back"><i className="fa fa-arrow-left"></i> All openings</Link>
                                <div>{job?.department && <span className="pp-eyebrow">{job.department}</span>}</div>
                                <h1>{job?.title}</h1>
                                <div className="jd-facts">
                                    {job?.experience && (
                                        <div className="jd-fact"><small>Experience</small><b><i className="fa fa-briefcase"></i>{formatExperience(job.experience)}</b></div>
                                    )}
                                    {job?.salary && (
                                        <div className="jd-fact"><small>Salary</small><b><i className="fa fa-money"></i>{job.salary}</b></div>
                                    )}
                                    <div className="jd-fact"><small>Posted</small><b><i className="fa fa-clock-o"></i>{timeAgo(job?.created_at)}</b></div>
                                </div>
                            </div>
                        </header>

                        <div className="pp-wrap">
                            <div className="jd-layout">
                                <div className="jd-main">
                                    <h2>About the role</h2>
                                    <div className="jd-desc" dangerouslySetInnerHTML={{ __html: renderBody(job?.description) }}></div>

                                    <div className="jd-steps">
                                        <h3>What happens after you apply</h3>
                                        <ol>
                                            <li><span>1</span>We review your application and resume.</li>
                                            <li><span>2</span>If it's a match, we'll contact you by email or phone.</li>
                                            <li><span>3</span>We'll keep you updated on the outcome.</li>
                                        </ol>
                                    </div>
                                </div>

                                <aside className="jd-apply">
                                    {submitted ? (
                                        <div className="jd-done">
                                            <div className="tick"><i className="fa fa-check"></i></div>
                                            <h3>Application sent</h3>
                                            <p>Thanks for applying, {name.split(' ')[0] || 'friend'}. We'll be in touch if it's a match.</p>
                                            <Link to="/careers" className="pp-btn ghost">See other openings</Link>
                                        </div>
                                    ) : (
                                        <form onSubmit={handleApply}>
                                            <h2>Apply for this role</h2>
                                            <p className="sub">It takes about a minute.</p>
                                            <div className="jd-field">
                                                <label htmlFor="jd-name">Full name</label>
                                                <input id="jd-name" type="text" className="jd-input" required value={name} onChange={(e) => setName(e.target.value)} />
                                            </div>
                                            <div className="jd-field">
                                                <label htmlFor="jd-email">Email</label>
                                                <input id="jd-email" type="email" className="jd-input" required value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </div>
                                            <div className="jd-field">
                                                <label htmlFor="jd-phone">Phone <span className="opt">(optional)</span></label>
                                                <PhoneInput id="jd-phone" className="jd-input" onChange={setPhone} />
                                            </div>
                                            <div className="jd-field">
                                                <label>Resume <span className="opt">(optional)</span></label>
                                                <label className="jd-file" htmlFor="jd-resume" style={{ marginBottom: 0 }}>
                                                    <i className={`fa ${resume ? 'fa-file-text-o' : 'fa-cloud-upload'}`}></i>
                                                    <span>
                                                        <span className="name">{resume ? resume.name : 'Choose a file'}</span>
                                                        <span className="hint" style={{ display: 'block' }}>PDF or Word, up to 5 MB</span>
                                                    </span>
                                                    <input id="jd-resume" type="file" accept=".pdf,.doc,.docx" onChange={(e) => setResume(e.target.files[0] || null)} />
                                                </label>
                                            </div>
                                            <div className="jd-field">
                                                <label htmlFor="jd-note">Cover note <span className="opt">(optional)</span></label>
                                                <textarea id="jd-note" className="jd-input" rows={4} value={coverNote} onChange={(e) => setCoverNote(e.target.value)} placeholder="Tell us a little about yourself" />
                                            </div>
                                            <button type="submit" className="pp-btn" disabled={submitting}>
                                                {submitting ? <><i className="fa fa-spinner fa-spin"></i> Submitting</> : 'Submit application'}
                                            </button>
                                        </form>
                                    )}
                                </aside>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="pp-state">
                        <i className="fa fa-briefcase"></i>
                        <p>This job posting is no longer available.</p>
                        <Link to="/careers" className="pp-btn">See open roles</Link>
                    </div>
                )}
            </div>
            <Footer />
        </>
    )
}

export default JobDetail
